import React from "react";
import { Skeleton, Box, Grid, Avatar } from "@mui/material";

const UserListSkeleton = () => {
  return (
    <Box sx={{ width: "100%" }}>
      {[...Array(9)].map((_, index) => (
        <Grid
          container
          alignItems="center"
          spacing={4}
          key={index}
          sx={{ marginBottom: 2 }}
        >
          <Grid item xs={0.5}>
            <Skeleton width={20} height={40}></Skeleton>
          </Grid>
          <Grid item xs={0.5}>
            <Skeleton variant="circular" width={40} height={40}>
              <Avatar />
            </Skeleton>
          </Grid>
          <Grid item xs={3.5}>
            <Skeleton variant="text" width="50%" height={30} />
          </Grid>
          <Grid item xs={0.5}>
            <Skeleton variant="text" width="50%" height={30} />
          </Grid>
          <Grid item xs={2}>
            <Skeleton variant="text" width="100%" />
          </Grid>
          <Grid item xs={2}>
            <Skeleton variant="text" width="100%" />
          </Grid>
          <Grid item xs={0.5}>
            <Skeleton variant="text" width="100%" />
          </Grid>
          <Grid item xs={0.5}>
            <Skeleton variant="text" width="100%" />
          </Grid>
          <Grid item xs={0.5}>
            <Skeleton variant="text" width="100%" />
          </Grid>
          <Grid item xs={0.5}>
            <Skeleton variant="rectangular" width={30} height={30} />
          </Grid>
          <Grid item xs={1}>
            <Skeleton variant="circular" width={30} height={30} />
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};

export default UserListSkeleton;
